module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.064 16H18v7a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-7h-3.064c-.932 0-1.216-.38-.634-1.182l4.644-6.252c.58-.8 1.526-.73 2.108.07l4.644 6.146c.584.804.298 1.218-.634 1.218z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-circle-3.js
// module id = 1475
// module chunks = 14